import { displayDateTime } from "../utils/helpers";

const baseURL = process.env.REACT_APP_BASE_URL;
// const baseURL = "http://localhost:8080/api";

//TODO: change this firebase function
const handleLlmUsageMeasure = async (model, functionalityUsage, status) => {
  if (window.location.hostname !== "www.brandluminaire.ai") {
    const apiMeasurePayload = {
      llm: model,
      // date: displayDateTime(),
      date: "",
      functionalityUsage: functionalityUsage,
      status: status,
    };
    const url = `https://us-central1-brand-luminaire.cloudfunctions.net/addLlmUsageMeasure`;
    const API_CONFIG = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(apiMeasurePayload),
    };

    await fetch(url, API_CONFIG);
  }
};

export async function fetchGooeyAPI(
  inputPrompt,
  selectedOption,
  abortController
) {
  const payload = {
    input_prompt: inputPrompt,
    selected_models: [selectedOption], // Modify to handle one selected item at a time
    avoid_repetition: false,
    num_outputs: 1,
    quality: 1,
    max_tokens: 800,
    sampling_temperature: 0.7,
    variables: null,
  };

  try {
    const url = `${baseURL}/fetchGooeyAPI`;
    const API_CONFIG = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
      signal: abortController?.signal,
    };

    const response = await fetch(url, API_CONFIG);
    if (response.status !== 200) {
      throw new Error();
    }
    return response.json();
  } catch (err) {
    throw new Error(err);
  }
}

export async function fetchGpt4API(
  inputPrompt,
  abortController,
  max_tokens = 800,
  temperature = 1,
  model = "gpt-4",
  response_format = {},
  functionalityUsage = "Reporting"
) {
  let payload = {
    messages: [
      {
        role: "user",
        content: inputPrompt,
      },
    ],
    max_tokens: max_tokens,
    model: model,
  };

  if (model !== "gpt-4o-search-preview") {
    payload = {
      ...payload,
      temperature,
      top_p: 1,
      frequency_penalty: 0,
      presence_penalty: 0,
    };
  }

  if (Object.keys(response_format).length > 0) {
    payload.response_format = response_format;
  }

  try {
    const url = `${baseURL}/fetchGptAPI`;
    const API_CONFIG = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
      signal: abortController?.signal,
    };

    const response = await fetch(url, API_CONFIG);
    if (response.status !== 200) {
      throw new Error();
    }
    await handleLlmUsageMeasure(model, functionalityUsage, "processed");
    return response.json();
  } catch (err) {
    await handleLlmUsageMeasure(model, functionalityUsage, "failed");
    throw new Error(err);
  }
}

export async function fetchLlama2API(
  inputPrompt,
  abortController,
  temperature = 0.9,
  functionalityUsage = "Reporting"
) {
  const payload = {
    messages: [{ role: "user", content: inputPrompt }],
    temperature,
  };
  try {
    const url = `${baseURL}/fetchLlama2API`;
    const API_CONFIG = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
      signal: abortController?.signal,
    };

    const response = await fetch(url, API_CONFIG);
    if (response.status !== 200) {
      throw new Error();
    }
    await handleLlmUsageMeasure("Llama2", functionalityUsage, "processed");
    return response.json();
  } catch (err) {
    await handleLlmUsageMeasure("Llama2", functionalityUsage, "failed");
    throw new Error(err);
  }
}

export async function fetchLlama3API(
  inputPrompt,
  abortController,
  temperature = 0.1,
  functionalityUsage = "Reporting"
) {
  const payload = {
    messages: [{ role: "user", content: inputPrompt }],
    temperature,
  };
  try {
    const url = `${baseURL}/fetchLlama3API`;
    const API_CONFIG = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
      signal: abortController?.signal,
    };

    const response = await fetch(url, API_CONFIG);
    if (response.status !== 200) {
      throw new Error();
    }
    await handleLlmUsageMeasure("Llama3", functionalityUsage, "processed");
    return response.json();
  } catch (err) {
    await handleLlmUsageMeasure("Llama3", functionalityUsage, "failed");
    throw new Error(err);
  }
}

export async function fetchSlackAPI(payload, abortController) {
  try {
    const url = `${baseURL}/fetchSlackAPI`;
    const API_CONFIG = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
      signal: abortController?.signal,
    };

    const response = await fetch(url, API_CONFIG);
    if (response.status !== 200) {
      throw new Error();
    }
    return response.json();
  } catch (err) {
    throw new Error(err);
  }
}

export async function fetchClaude3API(
  inputPrompt,
  abortController,
  temperature = 1.0,
  max_tokens = 2000,
  functionalityUsage = "Reporting"
) {
  const payload = {
    model: "claude-3-5-sonnet-20240620",
    max_tokens,
    temperature,
    messages: [{ role: "user", content: inputPrompt }],
  };
  try {
    const url = `${baseURL}/fetchClaude3API`;
    const API_CONFIG = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
      signal: abortController?.signal,
    };

    const response = await fetch(url, API_CONFIG);
    if (response.status !== 200) {
      throw new Error();
    }
    await handleLlmUsageMeasure("Claude3", functionalityUsage, "processed");
    return response.json();
  } catch (err) {
    await handleLlmUsageMeasure("Claude3", functionalityUsage, "failed");
    throw new Error(err);
  }
}

export async function fetchPerplexityAPI(
  inputPrompt,
  abortController,
  temperature = 1.0,
  max_tokens = 2000,
  model = "sonar",
  functionalityUsage = "Reporting"
) {
  const payload = {
    model,
    messages: [
      {
        role: "user",
        content: inputPrompt,
      },
    ],
    max_tokens,
    temperature,
  };
  try {
    const url = `${baseURL}/fetchPerplexityAPI`;
    const API_CONFIG = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
      signal: abortController?.signal,
    };

    const response = await fetch(url, API_CONFIG);
    if (response.status !== 200) {
      throw new Error();
    }
    await handleLlmUsageMeasure("Perplexity", functionalityUsage, "processed");
    return response.json();
  } catch (err) {
    await handleLlmUsageMeasure("Perplexity", functionalityUsage, "failed");
    throw new Error(err);
  }
}

export async function fetchGeminiAPI(
  inputPrompt,
  abortController,
  temperature = 0.9,
  functionalityUsage = "Reporting"
) {
  const payload = { llm: "Gemini", prompt: inputPrompt, temperature };
  try {
    const url = `${baseURL}/fetchGeminiAPI`;
    const API_CONFIG = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
      signal: abortController?.signal,
    };

    const response = await fetch(url, API_CONFIG);
    if (response.status !== 200) {
      throw new Error();
    }
    await handleLlmUsageMeasure("Gemini", functionalityUsage, "processed");
    return response.json();
  } catch (err) {
    await handleLlmUsageMeasure("Gemini", functionalityUsage, "failed");
    throw new Error(err);
  }
}

export async function checkWebLink(link, abortController) {
  const payload = { link };
  const url = `${baseURL}/checkWebLink`;
  const API_CONFIG = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
    signal: abortController.signal,
  };

  const response = await fetch(url, API_CONFIG);
  return response.json();
}

export async function fetchDataFromChatGPTWeb(payload, abortController) {
  try {
    const url = `${baseURL}/fetchDataFromChatGPTWeb`;
    const API_CONFIG = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
      signal: abortController?.signal,
    };
    const response = await fetch(url, API_CONFIG);
    if (response.status !== 200) {
      throw new Error();
    }
    return response.json();
  } catch (err) {
    throw new Error(err);
  }
}

export async function fetchFromGoogleSGE(inputPrompt, abortController) {
  const id = crypto.randomUUID();
  const payload = { prompt: inputPrompt, id: id };
  try {
    const url = `${baseURL}/fetchFromGoogleSGE`;
    const API_CONFIG = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
      signal: abortController?.signal,
    };
    const response = await fetch(url, API_CONFIG);
    if (response.status !== 200) {
      throw new Error();
    }
    return response.json();
  } catch (err) {
    throw new Error(err);
  }
}

export async function addReportingJob(payload, abortController) {
  try {
    const url = `${baseURL}/addReportingJob`;
    const API_CONFIG = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
      signal: abortController?.signal,
    };
    const response = await fetch(url, API_CONFIG);
    if (response.status !== 200) {
      throw new Error();
    }
    return response.json();
  } catch (err) {
    throw new Error(err);
  }
}

export async function triggerReportingJob(payload, abortController) {
  try {
    const url = `${baseURL}/triggerReportingJob`;
    const API_CONFIG = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
      signal: abortController?.signal,
    };
    const response = await fetch(url, API_CONFIG);
    if (response.status !== 200) {
      throw new Error();
    }
    return response.json();
  } catch (err) {
    throw new Error(err);
  }
}

export async function fetchBrandNames() {
  const url = `${baseURL}/getbrands`;
  const API_CONFIG = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  };
  const result = await fetch(url, API_CONFIG);
  return result.json();
}

export async function fetchProductNames() {
  const url = `${baseURL}/getproducts`;
  const API_CONFIG = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  };
  const result = await fetch(url, API_CONFIG);
  return result.json();
}

export async function fetchLlms() {
  const url = `${baseURL}/getllms`;
  const API_CONFIG = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  };
  const result = await fetch(url, API_CONFIG);
  return result.json();
}

export async function getLlms() {
  const url = `${baseURL}/llms`;
  const token = localStorage.getItem("token");
  const API_CONFIG = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  const result = await fetch(url, API_CONFIG);
  return result.json();
}

export async function getMarkets() {
  const url = `${baseURL}/markets`;
  const token = localStorage.getItem("token");
  const API_CONFIG = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  const result = await fetch(url, API_CONFIG);
  return result.json();
}

export async function getGeographies() {
  const url = `${baseURL}/geographies`;
  const token = localStorage.getItem("token");
  const API_CONFIG = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  const result = await fetch(url, API_CONFIG);
  return result.json();
}

export async function fetchCustomerLlms(id) {
  // const url = `${baseURL}/getllms`;
  const url = `${baseURL}/customers/llms`;
  const token = localStorage.getItem("token");
  const API_CONFIG = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ id }),
  };
  const result = await fetch(url, API_CONFIG);
  return result.json();
}

export async function getCustomerLlmGeoMarket(payload) {
  const url = `${baseURL}/customers/customer-llm-geo-market`;
  const API_CONFIG = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  };
  const result = await fetch(url, API_CONFIG);
  return result.json();
}

export async function getAttributes(payload) {
  const url = `${baseURL}/getattributes`;
  const API_CONFIG = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  };
  const result = await fetch(url, API_CONFIG);
  return result.json();
}

export async function getProductAttributes(payload) {
  // const url = `http://localhost:8080/api/product-attributes`;
  const url = `${baseURL}/product-attributes`;
  const token = localStorage.getItem("token");

  const API_CONFIG = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  };
  const result = await fetch(url, API_CONFIG);
  return result.json();
}

export async function getBrandAttributes(payload) {
  const url = `${baseURL}/brand-attributes`;
  // const url = `http://localhost:8080/api/brand-attributes`;
  const token = localStorage.getItem("token");

  const API_CONFIG = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",

      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  };
  const result = await fetch(url, API_CONFIG);
  return result.json();
}

export async function getActionSources(payload) {
  // const url = `${baseURL}/getattributes`;
  const url = `${baseURL}/metrics/metric-action-sources`;
  const token = localStorage.getItem("token");

  const API_CONFIG = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  };
  const result = await fetch(url, API_CONFIG);
  return result.json();
}

export async function getProductCoreAttributes(payload) {
  // const url = `${baseURL}/getattributes`;
  const url = `${baseURL}/product-core-attributes`;
  const token = localStorage.getItem("token");

  const API_CONFIG = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  };
  const result = await fetch(url, API_CONFIG);
  return result.json();
}

export async function getBrandCoreAttributes(payload) {
  // const url = `${baseURL}/getattributes`;
  const url = `${baseURL}/brand-core-attributes`;
  const token = localStorage.getItem("token");

  const API_CONFIG = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  };
  const result = await fetch(url, API_CONFIG);
  return result.json();
}

export async function getBrandIndexScore(payload, abortController) {
  const url = `${baseURL}/metrics/get-brand-index-score`;
  const API_CONFIG = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
    signal: abortController.signal,
  };

  const response = await fetch(url, API_CONFIG);
  return response.json();
}

export async function getBrandIndexScores(payload, abortController) {
  const url = `${baseURL}/getbrandindexscores`;

  // const url = 'http://localhost:9090/api/getbrandindexscores'
  const API_CONFIG = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  };
  const result = await fetch(url, API_CONFIG);
  return result.json();
}

export async function getIndexScoreForBrand(payload) {
  // const url = `${baseURL}/getattributes`;
  const url = `${baseURL}/brand-index-score`;
  const token = localStorage.getItem("token");

  const API_CONFIG = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  };
  const result = await fetch(url, API_CONFIG);
  return result.json();
}

export async function getIndexScoreForProduct(payload) {
  // const url = `${baseURL}/getattributes`;
  const url = `${baseURL}/product-index-score`;
  const token = localStorage.getItem("token");

  const API_CONFIG = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  };
  const result = await fetch(url, API_CONFIG);
  return result.json();
}

export async function generateBrandMetrics(llmId, brandPersonaId) {
  // const url = `${baseURL}/getattributes`;
  const url = `${baseURL}/generate-brand-metrics`;
  const token = localStorage.getItem("token");

  const API_CONFIG = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ llmId, brandPersonaId }),
  };
  const result = await fetch(url, API_CONFIG);
  return result.json();
}

export async function generateProductMetrics(llmId, brandProductPersonaId) {
  // const url = `${baseURL}/getattributes`;
  const url = `${baseURL}/generate-product-metrics`;
  const token = localStorage.getItem("token");

  const API_CONFIG = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ llmId, brandProductPersonaId }),
  };
  const result = await fetch(url, API_CONFIG);
  return result.json();
}

export async function getCompMetricsForProduct(payload) {
  const url = `${baseURL}/product-comp-metrics`;
  // const url = ` http://localhost:8080/api/product-comp-metrics`;

  const token = localStorage.getItem("token");

  const API_CONFIG = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  };
  const result = await fetch(url, API_CONFIG);
  return result.json();
}

export async function getCustomerMetrcisAlertsData(payload) {
  const url = `${baseURL}/customer-metrics-alerts-data`;
  const token = localStorage.getItem("token");

  const API_CONFIG = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  };
  const result = await fetch(url, API_CONFIG);
  return result.json();
}

export async function getCustomerEfrLlm(payload) {
  const url = `${baseURL}/customer-efr-llm`;
  // const url = `http://localhost:8080/api/brand-comp-metrics`;
  const token = localStorage.getItem("token");

  const API_CONFIG = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  };
  const result = await fetch(url, API_CONFIG);
  return result.json();
}

export async function getSourcesWithAlias(payload) {
  const url = `${baseURL}/source-alias`;
  // const url = `http://localhost:8080/api/brand-comp-metrics`;
  const token = localStorage.getItem("token");

  const API_CONFIG = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  };
  const result = await fetch(url, API_CONFIG);
  return result.json();
}

export async function addActionsIntoList(payload, id) {
  const url = `${baseURL}/customer/${id}/action-list`;
  const token = localStorage.getItem("token");

  const API_CONFIG = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  };
  const result = await fetch(url, API_CONFIG);
  return result.json();
}

export async function getCompMetricsForBrand(payload) {
  const url = `${baseURL}/brand-comp-metrics`;
  // const url = `http://localhost:8080/api/brand-comp-metrics`;
  const token = localStorage.getItem("token");

  const API_CONFIG = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  };
  const result = await fetch(url, API_CONFIG);
  return result.json();
}

export async function getNonActionableMetricData(payload) {
  const url = `${baseURL}/non-actionable-data`;
  // const url = `http://localhost:8080/api/brand-comp-metrics`;
  const token = localStorage.getItem("token");

  const API_CONFIG = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  };
  const result = await fetch(url, API_CONFIG);
  return result.json();
}

export async function getSummaryDataForBrandProduct(
  customerLlmId,
  customerPersonaId
) {
  const url = `${baseURL}/customer-brand-product-summary`;
  // const url = `http://localhost:8080/api/customer-brand-product-summary`;

  const token = localStorage.getItem("token");

  const API_CONFIG = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ customerLlmId, customerPersonaId }),
  };
  const result = await fetch(url, API_CONFIG);
  return result.json();
}
function cleanMarkdownString(input) {
  let cleaned = input.trim().replace(/^```|```$/g, "");
  cleaned = cleaned.replace(/^(markdown|md)\s*/i, "");
  return cleaned.trim();
}

export async function llmWeb(llm, focus_area, brand, attributes, prompt) {
  const payload = {
    llm: llm,
    focus_area,
    brand: brand,
    attributes: attributes,
    prompt: prompt,
  };
  try {
    const url = `${baseURL}/llm-web`;
    const API_CONFIG = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
      signal: new AbortController()?.signal,
    };

    const response = await fetch(url, API_CONFIG);
    if (response.status !== 200) {
      throw new Error();
    }
    const data = await response.json();
    return {
      LLM_WEB: [cleanMarkdownString(data["LLM_WEB"])],
    };
  } catch (err) {
    throw new Error(err);
  }
}

export async function getCustomerCases(customerId) {
  const url = `${baseURL}/customer/${customerId}/customer-case-list`;
  const token = localStorage.getItem("token");
  const API_CONFIG = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  const result = await fetch(url, API_CONFIG);
  return result.json();
}

export async function getCustomerMonitoringFiletrs(customerId) {
  const url = `${baseURL}/customers/${customerId}/customer-monitoring-filters`;
  const token = localStorage.getItem("token");
  const API_CONFIG = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  const result = await fetch(url, API_CONFIG);
  return result.json();
}

export async function getCustomerMonitoringDates(customerId, payload) {
  const url = `${baseURL}/customers/${customerId}/customer-monitoring-dates`;
  const token = localStorage.getItem("token");
  const API_CONFIG = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  };
  const result = await fetch(url, API_CONFIG);
  return result.json();
}

export async function getCustomerBrandProductCases(
  customerId,
  brand_names,
  product_names
) {
  const url = `${baseURL}/customer/${customerId}/customer-brand-product-associations`;
  const token = localStorage.getItem("token");
  const API_CONFIG = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ brand_names, product_names }),
  };
  const result = await fetch(url, API_CONFIG);
  return result.json();
}

export async function getAllBrands() {
  // const url = `${baseURL}/getattributes`;
  const url = `${baseURL}/customers/brands`;
  const token = localStorage.getItem("token");

  const API_CONFIG = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  const result = await fetch(url, API_CONFIG);
  return result.json();
}

export async function getDashboardSummary(payload) {
  const url = `${baseURL}/generate-dashboard-summary`;
  const token = localStorage.getItem("token");

  const API_CONFIG = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  };
  const result = await fetch(url, API_CONFIG);
  return result.json();
}

export async function getHomepageNews(payload) {
  const url = `${baseURL}/get-homepage-news`;
  const token = localStorage.getItem("token");

  const API_CONFIG = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  };
  const result = await fetch(url, API_CONFIG);
  return result.json();
}

export async function getActionMetricsData(payload) {
  const url = `${baseURL}/action-metrics`;
  const token = localStorage.getItem("token");

  const API_CONFIG = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  };
  const result = await fetch(url, API_CONFIG);
  return result.json();
}

export async function getRealtimeActions(payload) {
  const url = `${baseURL}/realtime-actions`;
  const token = localStorage.getItem("token");

  const API_CONFIG = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  };
  const result = await fetch(url, API_CONFIG);
  return result.json();
}

export async function getRealtimeActionsSource(payload) {
  const url = `${baseURL}/realtime-actions-sources`;
  const token = localStorage.getItem("token");

  const API_CONFIG = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  };
  const result = await fetch(url, API_CONFIG);
  return result.json();
}

export async function getRecommendedActions(customerId) {
  const url = `${baseURL}/get-recommended-actions/${customerId}`;
  const token = localStorage.getItem("token");

  const API_CONFIG = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  const result = await fetch(url, API_CONFIG);
  return result.json();
}

export async function newVersionAvailableToRefresh() {
  try {
    const response = await fetch(`${baseURL}/utils/get-frontend-version`);
    if (!response.ok) return false; // Handle non-200 status codes

    const { frontend_build_version } = await response.json();
    const local_version = localStorage.getItem("frontend_build_version");

    // Compare current version with local version and update if needed
    if (+local_version !== +frontend_build_version) {
      localStorage.setItem("frontend_build_version", frontend_build_version);
      return true; // New version available
    }

    return false; // No new version
  } catch (error) {
    console.error("Error fetching version:", error);
    return false; // Return false in case of an error
  }
}

export async function getReportingData(customerId) {
  try {
    // const response = await fetch(`${baseURL}/llm-reporting`, {
    const response = await fetch(
      `${baseURL}/llm-reporting?customer_id=${customerId}`
    );
    if (!response.ok) return false;
    const reportData = await response.json();
    return reportData;
  } catch (error) {
    console.error("Error :", error);
    return null;
  }
}

export async function updateReportingData(payload) {
  try {
    const response = await fetch(`${baseURL}/llm-reporting`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });
    if (!response.ok) throw new Error(`Response status: ${response.status}`);
    return response.json();
  } catch (error) {
    console.error("Error :", error);
    return null; // Return false in case of an error
  }
}
